import { Component } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

import { ErrorPageLayoutComponent } from '@core/components/error-page-layout/error-page-layout.component';

@Component({
  selector: 'app-not-found',
  imports: [TranslatePipe, ErrorPageLayoutComponent],
  templateUrl: './not-found.component.html',
  styles: ``
})
export class NotFoundComponent {}
